import React from 'react';
import Flux  from '../../../flux/Flux';

function withWindowWidth(T) {
	class WindowWidthObserver extends React.Component {

		constructor(props) {
			super(props);

			this.state = {
				windowWidth: Flux.Browser.getWindowSize().width,
			};

			this.onWindowResize = this.onWindowResize.bind(this);
		}

		componentDidMount() {
			Flux.Browser.addWindowResizeListener(this.onWindowResize);
		}

		componentWillUnmount() {
			Flux.Browser.removeWindowResizeListener(this.onWindowResize);
		}

		onWindowResize() {
			this.setState({
				windowWidth: Flux.Browser.getWindowSize().width,
			});
		}

		render() {
			return (<T {...this.state} {...this.props} />);
		}

	}

	return WindowWidthObserver;
}

export default withWindowWidth;